
export default function MiniStatCard({ title, value, amount }) {
  return (
    <div className="mini-card mt-3 flex-fill p-3">
      <div className="d-flex justify-content-between">
        <span className="text-muted">{title}</span>
        <span className="fw-bold">{value}</span>
      </div>

      <div className="d-flex justify-content-between mt-2">
        <span className="text-muted">Revenue</span>
        <span className="fw-bold">₹ {amount}</span>
      </div>
    </div>
  );
}